module.exports = __webpack_public_path__ + "img/close.a1d6a552.svg";